export const LOADER_STATUS = "boilerplate/ImsReco/DataUpload/LOADER_STATUS";
export const TABLE_DATA = "boilerplate/ImsReco/DataUpload/TABLE_DATA";
export const TOTAL_PAGES = "boilerplate/ImsReco/DataUpload/TOTAL_PAGES";
export const SET_ENTITY_LIST = "boilerplate/ImsReco/DataUpload/SET_ENTITY_LIST";
export const SET_SELECTED_ENTITY = "boilerplate/ImsReco/DataUpload/SET_SELECTED_ENTITY";

export const typeMap = {
  pass: "P",
  fail: "F",
  total: "T",
};

export const pageLimit = 10;